<template>
    <span class="mb-1">
        <badge v-if="orderStatus === ORDER_ACTIONS.PENDING" type="primary">
            <i class="fa fa-truck mr-1"></i>
            Pending
        </badge>
        <badge v-if="orderStatus === ORDER_ACTIONS.APPROVED" type="primary">
            <i class="fa fa-truck mr-1"></i>
            Approved
        </badge>
        <badge v-if="orderStatus === ORDER_ACTIONS.READY" type="primary">
            <i class="fa fa-truck mr-1"></i>
            Ready
        </badge>
        <badge v-if="orderStatus === ORDER_ACTIONS.PICKED_UP" type="primary">
            <i class="fa fa-truck mr-1"></i>
            Picked Up
        </badge>
        <badge v-if="orderStatus === ORDER_ACTIONS.DELIVERED" type="success">
            <i class="fa fa-truck mr-1"></i>
            Delivered
        </badge>
        <badge v-if="orderStatus === ORDER_ACTIONS.CANCELED" type="danger">
            <i class="fa fa-truck mr-1"></i>
            Canceled
        </badge>
    </span>
</template>
<script>
import { ORDER_ACTIONS } from '@/utils/constants'
import { Badge } from '@/components/UIComponents'
export default {
    components: {
        Badge
    },
    props: {
        orderStatus: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            ORDER_ACTIONS
        }
    }
}
</script>

<style lang="scss" scoped>
.p-badge {
    margin-right: 0.25rem;
}
</style>
